import { useEffect, useState, useContext, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import useSession from "../hooks/useSession";
import authAPI from "../services/auth";
import { UserContext } from "../context/UserContext";
import projectAPI from "../services/project";
import projectLogAPI from "../services/project-log";
import ShareProject from "./ShareProject";
import CollaboratorsModal from "./CollaboratorsModal";
import { marked } from 'marked';

import moment from "moment";
import 'moment/locale/hi';
import 'moment/locale/pt';

const Widget = () => {
  const [session] = useSession();
  const {
    user,
    setAuthUser,
    checkPermission,
    addCustomItem,
    getCustomItem,
    removeCustomItem,
    getL10nInstance
  } = useContext(UserContext);
  const [hash, setHash] = useState();
  const [isProjectView, setProjectView] = useState(false);
  const [current, setCurrent] = useState(0);
  const [last, setLast] = useState(1);
  const navigate = useNavigate();
  const location = useLocation();
  const [idProject, setIdProject] = useState();
  const [disableNew, setDisableNew] = useState(false);
  const [aditionalPermissions, setAditionalPermissions] = useState(null);
  const [filtered, setFiltered] = useState(false);
  const [keyword, setKeyword] = useState(null);
  const [projectInformation, setProjectInformation] = useState(null);
  const [invitationsSending, setInvitationsSending] = useState(false);

  const [message, setMessage] = useState('')
  const [sendEmail, setSendEmail] = useState(false)
  const [messages, setMessages] = useState([])
  const [page, setPage] = useState(1)
  const [pageSize, setPagesize] = useState(10)
  const [sending, setSending] = useState(false)
  const [collaborators, setCollaborators] = useState(0)
  const [total, setTotal] = useState(0)
  const [loadingLog, setLoadingLog] = useState(false)
  const [showModal, setShowModal] = useState(false)

  const [steps, setSteps] = useState([
    { title: "Project brief", completed: false },
    { title: "Invite participants", completed: false },
  ]);
  const [selectedTab, setSelectedTab] = useState(steps[0].title);
  const shareComponent = useRef(null);

  const [l10n, setL10n] = useState(null)

  useEffect(() => {
    const browserLanguage = navigator.language.split('-')[0];
    moment.locale(browserLanguage);
  }, []) 

  useEffect(() => {
    (async () => {
      const instance = await getL10nInstance()
      setL10n(instance)
    })()
  }, [session, user])

  const automaticPayment = async () => {
    let hashIdProject = null;
    // const projectInfo = ev.detail.data
    const projectInfo = projectInformation;
    if (sessionStorage.getItem("bunny.Project")) {
      const storageData = JSON.parse(sessionStorage.getItem("bunny.Project"));
      hashIdProject = storageData.hash_id_project;
    } else if (user && user.view) {
      hashIdProject = user.view.hash_id_project;
    }

    if (hashIdProject) {
      const data = {
        hash_id_project: hashIdProject,
        hash_id_widget_completed_form: projectInfo.hash_id_completed_form,
      };
      await projectAPI.post({ jwt: session, payload: data });
      sessionStorage.removeItem("bunny.Project");
      sessionStorage.removeItem("bunny.NewProjectEvent")
      sessionStorage.removeItem("bunny.Reloaded")
      navigate(
        `/widget#project/posted/${projectInfo.hash_id_completed_form}/payment/${projectInfo.hash_id_bill}/success`
      );
      // removeCustomItem("bunny.OpportunityCode");
      sessionStorage.removeItem("id_bill");
      sessionStorage.removeItem("completed_form");
      navigate(0);
    }
  };

  const nextStep = (e) => {
    const projectInfo = e.detail.data;
    setProjectInformation(projectInfo);

    toggleCompleted("Project brief");
    setSelectedTab("Invite participants");
  };

  const toggleCompleted = (title) => {
    const updated = steps.map((step) => {
      if (step.title === title) {
        return {
          ...step,
          completed: true,
        };
      }
      return step;
    });
    setSteps(updated);
  };

  const onNewProject = async () => {
    // Create project
    setDisableNew(true);
    const dummyData = {
      // TODO: use dynamic data
      opportunity_code: "12345678",
      fulfillment: "contest",
    };
    try {
      const res = await projectAPI.structure({
        jwt: session,
        payload: dummyData,
      });
      sessionStorage.setItem("bunny.Project", JSON.stringify(res.data.data));
      sessionStorage.setItem("bunny.NewProjectEvent", true);
      setDisableNew(false);
      navigate(`/widget#project`);
      navigate(0);
    } catch (error) {
      console.error(error);
      setDisableNew(false);
    }
  };
  useEffect(() => {
    (async () => {
      try {
        let permissions = undefined;

        if (session && !user) {
          const res = await authAPI.get({ jwt: session });
          const authUser = res.data.data;
          permissions = [
            ...authUser.project_permissions,
            ...authUser.global_permissions,
          ];
          setAuthUser(authUser);
        } else if (!user) {
          navigate("/login");
        }

        if (user) {
          permissions = [
            ...user.project_permissions,
            ...user.global_permissions,
          ];
        }
        const value = location.hash.replace("#", "");
        const projectView = checkProjectView(value);
        // if (!projectView) 
          await initWidget(null, permissions);
        // const ele = await waitForElm('widget')
        // ele.addEventListener('bsSubmit', automaticPayment)
      } catch (error) {
        console.log(error);
        navigate("/login");
      }
    })();
    return () => {
      // document.getElementById('widget').removeEventListener('bsSubmit', eventHandler)
    };
  }, []);

  const waitForElm = (selector) => {
    return new Promise((resolve) => {
      const checkExit = setInterval(() => {
        if (document.getElementById(selector)) {
          return resolve(document.getElementById(selector));
          clearInterval(checkExit);
        }
      }, 100);
    });
  };

  useEffect(() => {
    const value = location.hash.replace("#", "");
    setHash(value);
    checkProjectView(value);
  }, [location]);

  const checkProjectView = (value) => {
    const path = value.split("/");
    if (path.length == 3 && path[0] == "project" && path[1] == "posted") {
      setProjectView(true);
      setIdProject(path[2]);
      getProjectPermissions(path[2]);
      getProjectLog(page, path[2]);
      return true;
    } else if (
      path.length == 5 &&
      path[0] == "project" &&
      path[1] == "posted" &&
      ["history", "revision", "reject", "winner-revision"].includes(path[3])
    ) {
      setIdProject(path[2]);
      getProjectPermissions(path[2]);
      return true;
    }
    return false;
  };

  const getProjectPermissions = async (hash) => {
    const sessionData = getCustomItem("bunny.Projects");
    if (sessionData && sessionData != "undefined") {
      const temp = JSON.parse(sessionData);
      const filter = temp.filter(
        (item) => item.hash_id_widget_completed_form == hash
      );
      const project = filter && filter.length > 0 ? filter[0] : null;
      if (project) {
        setAditionalPermissions(project.project_permissions);
        await initWidget(null, project.project_permissions);
      }
      return;
    } else {
      let permissions = undefined;
      if (session && !user) {
        const res = await authAPI.get({ jwt: session });
        const authUser = res.data.data;
        permissions = [
          ...authUser.project_permissions,
          ...authUser.global_permissions,
        ];
      }
      if (user) {
        permissions = [...user.project_permissions, ...user.global_permissions];
      }
      await initWidget(null, permissions);
    }
  };

  const initWidget = async (
    offset = null,
    permissions = null,
    keyword = null
  ) => {
    const res = await projectAPI.get({ jwt: session, page: offset });
    const data = res.data.data;
    const projects =
      data.projects && data.projects.length > 0 ? data.projects : undefined;
    const pagObj = data.pagination ? data.pagination : null;
    const email = data.email ? data.email : undefined;

    if (pagObj) {
      const { start, limit, total } = pagObj;
      setCurrent(start);
      setLast(Math.ceil(total / limit));
    } else {
      getPaginationFromWidget(offset)
    }
    // Save project list in session
    addCustomItem("bunny.Projects", projects);

    const parsedProjects = projects && projects.length > 0 ? projects : null;
    renderWidget(email, parsedProjects, permissions, keyword, offset);
    return [projects, email];
  };

  const getPaginationFromWidget = (offset = null) => {
    const checkExit = setInterval(() => {
      if (sessionStorage.getItem('bs_pagination_projects')) {
        const paginationStorage = JSON.parse(sessionStorage.getItem('bs_pagination_projects'))
        const { start, limit, total } = paginationStorage;
        setCurrent(offset ? offset : start);
        setLast(Math.ceil(+total / limit));
        sessionStorage.removeItem('bs_pagination_projects')
        clearInterval(checkExit);
      }
    }, 100);
  }

  const renderWidget = async (email, projects, permissions, keyword = null, offset= null) => {
    const person = user
      ? user
      : (await authAPI.get({ jwt: session })).data.data;

    const wrapper = document.getElementById("widget-container");
    wrapper.innerHTML = "";

    const widget = document.createElement("be-widget");
    widget.setAttribute("id", "widget");
    widget.setAttribute("key-value", person.key_bunny_widget);
    if (projects) widget.setAttribute("projects", JSON.stringify(projects));
    if (permissions)
      widget.setAttribute("permissions", JSON.stringify(permissions));
    email
      ? widget.setAttribute("client-id", email)
      : widget.setAttribute("client-id", person.position == 'guest' ? person.view.email_am : person.email);
    if (person && person.view && person.view.opportunity_code) {
      widget.setAttribute("opportunity-code", person.view.opportunity_code);
    } else if (getCustomItem("bunny.OpportunityCode")) {
      const op = JSON.parse(getCustomItem("bunny.OpportunityCode"));
      widget.setAttribute("opportunity-code", op);
    }
    widget.setAttribute(
      "aditional-info",
      `[{"key": "q", "value": "${
        keyword ? keyword : ""
      }", "attribute": "opportunity_code"}]`
    );
    widget.setAttribute("paginator-page", offset !== null ? offset : current)
    if (person.email) widget.setAttribute("logged-user", person.email);
    if (person.position) widget.setAttribute("user-role", person.position);
    widget.addEventListener("bsSubmit", nextStep);
    wrapper.appendChild(widget);
  };

  // useEffect(() => {
  //   console.log(widgetInitialized);
  //   if(widgetInitialized){
  //     // Obtén todos los elementos con la clase 'bs-card'
  //     const cardElements = document.querySelectorAll('.bs-card');

  //     console.log(cardElements);
      
  //     // Agrega la clase 'rounded-[16px]' a cada elemento 'bs-card'
  //     cardElements.forEach((cardElement) => {
  //       cardElement.style.borderRadius = '16px';
  //       // cardElement.classList.add('rounded-[16px]');
        
  //       // Encuentra el elemento 'bs-button' dentro de 'bs-card'
  //       const buttonElement = cardElement.querySelector('.bs-button');
        
  //       if (buttonElement) {
  //         // Agrega la clase 'rounded-[25px]' al elemento 'bs-button'
  //         buttonElement.classList.add('rounded-[25px]');
  //       }
  //     });
  //   }
  // }, [widgetInitialized]);

  const handleClick = async (event) => {
    const target = event.target;
    const page = Number(target.dataset.page) - 1;
    if (Number.isNaN(page)) return false;
    if ((page * pageSize) === current) return false;
    await initWidget(page * pageSize, [
      ...user.project_permissions,
      ...user.global_permissions,
    ]);
  };

  const handleNext = async () => {
    const page = (current / pageSize) + 1;
    if (page > (last - 1)) return false;
    await initWidget(page * pageSize, [
      ...user.project_permissions,
      ...user.global_permissions,
    ]);
  };

  const handlePrev = async () => {
    const page = (current / pageSize) - 1;
    if (page < 0) return false;
    await initWidget(page * pageSize, [
      ...user.project_permissions,
      ...user.global_permissions,
    ]);
  };

  const onFilter = () => {
    if (filtered) setKeyword(null);
    const ele = document.getElementById("widget");
    if (ele) ele.setAttribute("loading", true);
    initWidget(
      null,
      [...user.project_permissions, ...user.global_permissions],
      filtered ? null : keyword
    );
    setFiltered(!filtered);
  };

  const paginator = () => {
    const delta = 2;
    const page = (current / pageSize) + 1;
    const left = page - delta;
    const right = page + delta + 1;
    const range = [];
    const rangeWithDots = [];
    let l;

    for (let i = 1; i <= last; i++) {
      if (i === 1 || i === last || (i >= left && i < right)) {
        range.push(i);
      }
    }

    for (const i of range) {
      if (l) {
        if (i - l === 2) {
          rangeWithDots.push(l + 1);
        } else if (i - l !== 1) {
          rangeWithDots.push("...");
        }
      }
      rangeWithDots.push(i);
      l = i;
    }

    return rangeWithDots;
  };

  const onTabClick = (title) => {
    if (title === "Project brief" && selectedTab != "Project brief") {
      initWidget();
    }

    const filterTab = steps.filter((step) => step.title == title);
    if (filterTab.length && filterTab[0].completed) {
      setSelectedTab(title);
    }
  };

  const sendInvitations = async () => {
    let hashIdProject = null;
    setInvitationsSending(true);
    if (sessionStorage.getItem("bunny.Project")) {
      const storageData = JSON.parse(sessionStorage.getItem("bunny.Project"));
      hashIdProject = storageData.hash_id_project;
    } else if (user && user.view) {
      hashIdProject = user.view.hash_id_project;
    }
    await shareComponent.current.externalSendInvitations(hashIdProject);
    setInvitationsSending(false);
    automaticPayment();
  };

  const getProjectLog = async (pageNum, id_project = null) => {
    try {
      // let hashIdProject = null
      // if (user && user.view) {
      //   hashIdProject = user.view.hash_id_project
      // } else if (getCustomItem('bunny.Project')) {
      //   const storageData = JSON.parse(getCustomItem('bunny.Project'))
      //   hashIdProject = storageData.hash_id_project
      // }
      setLoadingLog(true);
      const response = await projectLogAPI.get({
        jwt: session,
        project: id_project ? id_project : idProject,
        pageSize: pageSize,
        page: pageNum,
      });
      setMessages(response.data.data.projectLog);
      setTotal(response.data.data.count);
      setCollaborators(response.data.data.collaborators);
      setLoadingLog(false);
    } catch (error) {
      console.error(error);
    }
  };

  const sendMessagess = async () => {
    setSending(true);
    try {
      // let hashIdProject = null
      // if (user && user.view) {
      //   hashIdProject = user.view.hash_id_project
      // } else if (getCustomItem('bunny.Project')) {
      //   const storageData = JSON.parse(getCustomItem('bunny.Project'))
      //   hashIdProject = storageData.hash_id_project
      // }
      const payload = {
        hash_id_widget_completed_form: idProject,
        message: message,
        send_email: sendEmail
      }
      const response = await projectLogAPI.post({ jwt: session, payload })
      await getProjectLog(1)
      setPage(1)
      setSending(false)
      setMessage('')
      setSendEmail(false)
    } catch (error) {
      console.error(error);
      setSending(false);
    }
  };

  const showMoreChat = async () => {
    setSending(true);
    try {
      // let hashIdProject = null
      // if (user && user.view) {
      //   hashIdProject = user.view.hash_id_project
      // } else if (getCustomItem('bunny.Project')) {
      //   const storageData = JSON.parse(getCustomItem('bunny.Project'))
      //   hashIdProject = storageData.hash_id_project
      // }
      const response = await projectLogAPI.get({
        jwt: session,
        project: idProject,
        pageSize: pageSize,
        page: page + 1,
      });
      setMessages((prevState) => [
        ...prevState,
        ...response.data.data.projectLog,
      ]);
      setSending(false);
      setPage((prevState) => prevState + 1);
    } catch (error) {
      console.error(error);
      setSending(false);
    }
  };

  const getMessageCreator = (item) => {
    switch (item.type) {
      case 0:
      case 2:
        return l10n ? l10n.getString('Project update') : 'Project update';
      case 1:
        return item.role.user.email;
      default:
        return '';
    }
  };

  const getMessageColor = (item) => {
    switch (item.type) {
      case 1:
        return 'bg-[#ECECEC]';
      case 2:
        return 'bg-[#c6c6c6]';
      default:
        return 'bg-[#EBEBEB]';
    }
  };

  const getFinalMessage = (item) => {
    return l10n && (item.values ? l10n.getString(item.new_message, {}, item.values) : l10n.getString(item.message))
  }

  return (
    <>
    <section className={`${!isProjectView && "w-1/2 mx-auto"}`} id="project">
      {hash == "dashboard" ? (
        <div className="flex justify-between items-center mb-9">
          <h1 className="font-bold text-3xl">{l10n && l10n.getString('Your projects')}</h1>
          {user && user.position == "am" && checkPermission("P-NEW") ? (
            <div className="flex justify-evenly items-center h-12">
              <input
                id="email"
                className="block w-[341px] h-12 my-2 mr-4 px-[12px] py-[6px] border border-[#7C7C7C] rounded"
                type="text"
                placeholder={l10n && l10n.getString("State or opportunity code")}
                value={keyword ? keyword : ""}
                name="opportunity"
                onChange={(e) => setKeyword(e.target.value)}
              />
              <button
                type="button"
                className="w-[74px] h-9 rounded-[25px] text-[#6A4278] bg-white border border-[#7C7C7C] gap-1 text-[14px] items-center text-base font-semibold"
                onClick={() => onFilter()}
              >
                {l10n && l10n.getString('Filter')}
              </button>
            </div>
          ) : (
            ""
          )}
        </div>
      ) : (
        ""
      )}
      {hash == "dashboard" ? (
        <div className="flex justify-end">
          {/* <input
            id="email"
            className="block w-2/5 h-9 my-2 mr-4 px-[12px] py-[6px] border border-solid border-[#B6B7C0] rounded"
            type="text"
            placeholder="Opportunity code"
            value={keyword ? keyword : ""}
            name="opportunity"
            onChange={(e) => setKeyword(e.target.value)}
          />
          <button
            className="flex gap-1 text-[#A7A9B3] items-center text-base font-semibold"
            onClick={() => onFilter()}
          >
            {!filtered ? (
              <svg
                width="24px"
                height="24px"
                viewBox="0 0 512 512"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill="#A7A9B3"
                  d="M238.627,496H192V253.828l-168-200V16H480V53.612l-160,200V414.627ZM224,464h1.373L288,401.373V242.388L443.51,48H60.9L224,242.172Z"
                />
              </svg>
            ) : (
              ""
            )}
            {filtered ? (
              <svg
                width="24px"
                height="24px"
                viewBox="0 0 512 512"
                xmlns="http://www.w3.org/2000/svg"
              >
                <polygon
                  fill="#A7A9B3"
                  points="40 16 40 53.828 109.024 136 150.815 136 76.896 48 459.51 48 304 242.388 304 401.373 241.373 464 240 464 240 368 208 368 208 496 254.627 496 336 414.627 336 253.612 496 53.612 496 16 40 16"
                />
                <polygon
                  fill="#A7A9B3"
                  points="166.403 248.225 226.864 187.763 204.237 165.135 143.775 225.597 83.313 165.135 60.687 187.763 121.148 248.225 60.687 308.687 83.313 331.314 143.775 270.852 204.237 331.314 226.864 308.687 166.403 248.225"
                />
              </svg>
            ) : (
              ""
            )}
            </button>*/}
        </div>
      ) : (
        ""
      )}
      {/* <div id='widget-container'></div> */}
      {hash == "project" ? (
        <div>
          <Tabs
            tabs={steps}
            selectedTab={selectedTab}
            onTabClick={(title) => onTabClick(title)}
          />

          <div className="py-4">
            {selectedTab === "Project brief" && (
              <div id="widget-container"></div>
            )}
            {selectedTab === "Invite participants" && (
              <>
                <ShareProject
                  ref={shareComponent}
                  showMore
                  noMargin
                  noBack
                  noParticipants
                  noButton
                  title={l10n && l10n.getString("Creative Briefing Form")}
                />
                <CustomButton
                  length={projectInformation.project_data.adLength}
                  disabled={invitationsSending}
                  onClick={() => sendInvitations()}
                />
              </>
            )}
          </div>
        </div>
      ) : (
        <>
          {isProjectView ? (
            <div className="grid md:grid-cols-[3fr_2fr] gap-10 mx-20">
              <div id="widget-container"></div>
              <div className="max-h-[calc(100vh_-_122px)] overflow-auto">
                {isProjectView &&
                user &&
                checkPermission("P-SHA", aditionalPermissions) ? (
                  <div className="w-[100%] h-[54px] mb-[17px] px-4 py-2.5 bg-white rounded border border-stone-300 justify-start items-center gap-2 inline-flex">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g id="info-circle">
                        <path id="Path" fill-rule="evenodd" clip-rule="evenodd" d="M0.3125 10C0.3125 4.65168 4.65012 0.3125 10 0.3125C15.3499 0.3125 19.6875 4.65168 19.6875 10C19.6875 15.3514 15.3499 19.6875 10 19.6875C4.65012 19.6875 0.3125 15.3514 0.3125 10ZM2.1875 10C2.1875 14.3191 5.68234 17.8125 10 17.8125C14.3191 17.8125 17.8125 14.3176 17.8125 10C17.8125 5.68246 14.3161 2.1875 10 2.1875C5.6825 2.1875 2.1875 5.68379 2.1875 10ZM10 4.60938C10.9061 4.60938 11.6406 5.34391 11.6406 6.25C11.6406 7.15609 10.9061 7.89062 10 7.89062C9.09391 7.89062 8.35938 7.15609 8.35938 6.25C8.35938 5.34391 9.09391 4.60938 10 4.60938ZM11.7188 15C11.9776 15 12.1875 14.7901 12.1875 14.5312V13.5938C12.1875 13.3349 11.9776 13.125 11.7188 13.125H11.25V9.21875C11.25 8.95988 11.0401 8.75 10.7812 8.75H8.28125C8.02238 8.75 7.8125 8.95988 7.8125 9.21875V10.1562C7.8125 10.4151 8.02238 10.625 8.28125 10.625H8.75V13.125H8.28125C8.02238 13.125 7.8125 13.3349 7.8125 13.5938V14.5312C7.8125 14.7901 8.02238 15 8.28125 15H11.7188Z" fill="black"/>
                      </g>
                    </svg>
                    <p className="grow shrink basis-0 text-neutral-500 text-sm font-bold font-helveticaNeue leading-[21px]">
                      {l10n && l10n.getString('Invite collaborators and viewers to this project')}
                    </p>
                    <button
                      type="button"
                      onClick={() => navigate("../invite-people/" + idProject)}
                      className="px-5 py-1 bg-white rounded-[20px] border border-neutral-500 justify-center items-center gap-2 flex text-neutral-900 text-sm font-bold font-helveticaNeue leading-[19px]"
                    >
                      {l10n && l10n.getString('Share')}
                    </button>
                  </div>
                ) : (
                  ""
                )}
                <div className="border-b pb-[17px] border-[#D7DDED]">
                  <div className="flex justify-between mb-2">
                    <div className="text-slate-800 text-base font-bold font-helveticaNeue leading-loose">
                      {l10n && l10n.getString('Project activity')}
                    </div>
                    <div className="text-[#734D85] font-semibold text-sm">
                      {collaborators >= 0
                        ? 
                        (<div className="h-[21px] mr-4 justify-start items-center gap-1 inline-flex cursor-pointer select-none" onClick={() => setShowModal(true)}>
                          <div className="h-3 relative cursor-pointer">
                            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <g id="users">
                                <path id="Path" fill-rule="evenodd" clip-rule="evenodd" d="M8.1 3.90005C8.1 5.06067 7.16062 6.00005 6 6.00005C4.83938 6.00005 3.9 5.06067 3.9 3.90005C3.9 2.73942 4.83938 1.80005 6 1.80005C7.16062 1.80005 8.1 2.73942 8.1 3.90005ZM3 4.20005C3 4.86192 2.46187 5.40005 1.8 5.40005C1.13813 5.40005 0.6 4.86192 0.6 4.20005C0.6 3.53817 1.13813 3.00005 1.8 3.00005C2.46187 3.00005 3 3.53817 3 4.20005ZM11.4 4.20005C11.4 4.86192 10.8619 5.40005 10.2 5.40005C9.53813 5.40005 9 4.86192 9 4.20005C9 3.53817 9.53813 3.00005 10.2 3.00005C10.8619 3.00005 11.4 3.53817 11.4 4.20005ZM10.8 6.00005H9.6C9.27 6.00005 8.97188 6.13317 8.75438 6.3488C9.51 6.76317 10.0463 7.5113 10.1625 8.40005L11.4 8.40005C11.7319 8.40005 12 8.13192 12 7.80005V7.20005C12 6.53817 11.4619 6.00005 10.8 6.00005ZM7.44 6.60005H7.28437C6.89437 6.78755 6.46125 6.90005 6 6.90005C5.53875 6.90005 5.1075 6.78755 4.71562 6.60005H4.56C3.3675 6.60005 2.4 7.56755 2.4 8.76005V9.30005C2.4 9.79692 2.80313 10.2 3.3 10.2L8.7 10.2C9.19687 10.2 9.6 9.79692 9.6 9.30005L9.6 8.76005C9.6 7.56755 8.6325 6.60005 7.44 6.60005ZM2.4 6.00005C2.73 6.00005 3.02813 6.13317 3.24563 6.3488C2.49 6.76317 1.95375 7.5113 1.83563 8.40005H0.6C0.268125 8.40005 0 8.13192 0 7.80005L0 7.20005C0 6.53817 0.538125 6.00005 1.2 6.00005H2.4Z" fill="#734D85"/>
                              </g>
                            </svg>
                          </div>
                          <div className="text-[#734D85] text-zinc-500 text-sm font-bold font-helveticaNeue leading-[21px]">{l10n && `${collaborators} ${l10n.getString(`collaborator${collaborators > 1 ? "s" : ""}`)}`}
                          </div>
                        </div>)
                        : ""}
                        <div className="w-30 h-[21px] justify-start items-center gap-1 inline-flex cursor-pointer select-none">
                          <div 
                            className="w-3 h-3 p-[0.19px] -rotate-180 justify-center items-center flex"
                            onClick={() => {
                              setPage(1);
                              getProjectLog(1);
                            }}
                          >
                            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <g id="sync-alt">
                                <path id="Path" fill-rule="evenodd" clip-rule="evenodd" d="M6.00356 9.9375C4.99481 9.93839 4.04395 9.56231 3.31125 8.87625L4.28977 7.89776C4.64412 7.54338 4.39315 6.9375 3.89201 6.9375L0.75 6.9375C0.439336 6.9375 0.1875 7.18933 0.1875 7.5L0.1875 10.642C0.1875 11.1431 0.793383 11.3941 1.14773 11.0398L1.98481 10.2027C3.02834 11.1999 4.44263 11.8125 6 11.8125C8.84032 11.8125 11.2047 9.77522 11.7118 7.08225C11.7443 6.90954 11.6108 6.75 11.4351 6.75L10.092 6.75C9.96246 6.75 9.85048 6.83876 9.81898 6.96445C9.38625 8.69114 7.81898 9.93591 6.00356 9.9375ZM8.10799 5.0625L11.25 5.0625C11.5607 5.0625 11.8125 4.81066 11.8125 4.5L11.8125 1.35799C11.8125 0.856852 11.2066 0.605883 10.8523 0.960235L10.0152 1.7973C8.97166 0.800062 7.55738 0.1875 6 0.187499C3.15968 0.187499 0.795306 2.22478 0.288165 4.9177C0.255657 5.09041 0.389157 5.24995 0.564891 5.24995L1.90795 5.24995C2.03754 5.24995 2.14952 5.16119 2.18102 5.0355C2.61396 3.30804 4.18186 2.06412 5.99634 2.06248C7.00512 2.06156 7.95605 2.43764 8.68875 3.12373L7.71023 4.10224C7.35588 4.45662 7.60685 5.0625 8.10799 5.0625Z" fill="#734D85"/>
                              </g>
                            </svg>
                          </div>
                          <div className="text-[#734D85] text-zinc-500 text-sm font-bold font-helveticaNeue leading-[21px]">{l10n && l10n.getString('update feed')}</div>
                        </div>
                    </div>
                  </div>
                </div>
                <div className="flex flex-col-reverse my-4 max-h-[calc(100%_-_348px)] overflow-auto custom-overflow-y">
                  {messages.map((item) => (
                    <div>
                      <div className="mb-1 flex justify-between text-[#B6B7C0] text-xs">
                        <div className="text-neutral-500 text-[13px] font-bold font-helveticaNeue overflow-hidden whitespace-nowrap truncate">
                          {getMessageCreator(item)}
                        </div>
                        <div className="text-neutral-500 text-xs font-normal font-helveticaNeue overflow-hidden whitespace-nowrap truncate">
                          {moment(item.created_at).format(
                            "dddd, DD MMMM YYYY - HH:mm"
                          )}
                        </div>
                      </div>
                      {getFinalMessage(item) && <div
                        className={`p-2 font-helveticaNeue ${getMessageColor(item)} rounded-lg ${
                          item.send_email == 0 ? "mb-4" : "mb-1"
                        }`}
                        dangerouslySetInnerHTML={{ __html: marked(getFinalMessage(item)) }}
                      ></div>}
                      {item.send_email == 1 && (
                        <div className="text-[#B6B7C0] text-xs overflow-hidden whitespace-nowrap truncate mb-4 italic">
                          {l10n && l10n.getString('All collaborators were notified about this comment via email')}
                        </div>
                      )}
                    </div>
                  ))}
                  {messages.length < total ? (
                    <div
                      className="bg-white rounded-[20px] border border-neutral-500 py-2 px-4 m-auto mb-4 mt-2 cursor-pointer text-neutral-900 text-sm font-bold font-helveticaNeue hover:bg-[#f4f4f4]"
                      onClick={() => (sending ? null : showMoreChat())}
                    >
                      {l10n && l10n.getString('Show more')}
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
                <div className="text-[#6A6A6A] text-neutral-500 text-sm font-normal font-helveticaNeue leading-normal">
                  {l10n && l10n.getString('Comments are only for sharing information. Please use the deliverables tab to the left to approve deliverables or request revisions.')}
                </div>
                <div className="mb-0 flex justify-between items-center gap-4">
                  <input
                    id="message"
                    className="block w-full h-9 placeholder-[#7C7C7C] font-normal font-helveticaNeue leading-normal my-2 px-[12px] py-[6px] rounded border border-solid border-[#CCC] rounded resize-none"
                    placeholder={l10n && l10n.getString("Leave a comment")}
                    name="message"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                  />
                  <button
                    type="button"
                    className="text-neutral-900 w-[74px] text-sm font-bold font-helveticaNeue leading-[19px] rounded-[20px] border border-solid border-[#7C7C7C] text-base text-white bg-[#FFF] hover:bg-[#f4f4f4] px-3 py-2 rounded focus:outline-none"
                    onClick={sendMessagess}
                    disable={sending || message == ""}
                  >
                    <span>{l10n && l10n.getString('Send')}</span>
                  </button>
                </div>
                <label className="mt-4 inline-flex items-center cursor-pointer">
                  <input
                    className="w-4 h-4"
                    type="checkbox"
                    checked={sendEmail}
                    onChange={(e) => setSendEmail(!sendEmail)}
                  />
                  <span className="text-sm text-[#3D3F4B] ml-1">
                    {l10n && l10n.getString('Notify all collaborators via email')}
                  </span>
                </label>
              </div>
            </div>
          ) : (
            <div id="widget-container"></div>
          )}
        </>
      )}
      {hash == "dashboard" ? (
        <nav aria-label="Page navigation">
          <ul className="flex pl-0 list-none rounded justify-center mt-3">
            <li className="page-item">
              <button
                className="ml-0 rounded cursor-pointer relative block py-2 px-3 leading-5 text-black text-base font-bold hover:bg-purple-950 hover:bg-opacity-5"
                aria-label="NePreviousxt"
                onClick={() => handlePrev()}
              >
                <span aria-hidden="true" className="flex justify-between items-center">
                  <svg width="16" height="16" className="mr-[8px]" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="arrow-left">
                      <path id="Path" d="M9.06211 13.9096L8.36836 14.6033C8.07461 14.8971 7.59961 14.8971 7.30898 14.6033L1.23398 8.53144C0.940234 8.23769 0.940234 7.76269 1.23398 7.47207L7.30898 1.39707C7.60273 1.10332 8.07773 1.10332 8.36836 1.39707L9.06211 2.09082C9.35898 2.3877 9.35273 2.87207 9.04961 3.1627L5.28398 6.7502H14.2652C14.6809 6.7502 15.0152 7.08457 15.0152 7.5002V8.50019C15.0152 8.91582 14.6809 9.25019 14.2652 9.25019H5.28398L9.04961 12.8377C9.35586 13.1283 9.36211 13.6127 9.06211 13.9096Z" fill={!current  || (Math.floor(current / pageSize) + 1) == 1 ? "#888b9e" : "black"}/>
                    </g>
                  </svg>
                  <p className={"text-" + (!current  || (Math.floor(current / pageSize) + 1) == 1 ? "[#888b9e]" : "[black]") + " font-normal font-helveticaNeue"}>{l10n && l10n.getString('Previous')}</p>
                </span>
              </button>
            </li>
            {paginator().map((page, index) => (
              <li key={index} className="page-item">
                <button
                  id={"paginator-" + index}
                  className={
                    (Number(page) == (Math.floor(current / pageSize) + 1) 
                      ? "text-[#888b9e] text-base font-bold bg-purple-950 bg-opacity-5 z-[1] "
                      : "hover:text-black text-base font-bold hover:bg-purple-950 hover:bg-opacity-5 ") +
                    "ml-0 rounded cursor-pointer relative block py-2 px-3 leading-5 text-black text-base font-bold font-helveticaNeue"
                  }
                  data-page={page}
                  onClick={(e) => handleClick(e)}
                >
                  {page}
                </button>
              </li>
            ))}
            <li className="page-item">
              <button
                className="ml-0 rounded cursor-pointer relative block py-2 px-3 leading-5 text-black text-base font-bold text-black text-base font-bold hover:bg-purple-950 hover:bg-opacity-5"
                aria-label="Next"
                onClick={() => handleNext()}
              >
                <span aria-hidden="true" className="flex justify-between items-center">
                  <p className={`${last == (Math.floor(current / pageSize) + 1) && 'text-[#888b9e]'} font-normal font-helveticaNeue mr-[8px]`}>{l10n && l10n.getString('Next')}</p> 
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="arrow-right">
                      <path id="Path" d="M6.9375 2.09082L7.63125 1.39707C7.925 1.10332 8.4 1.10332 8.69063 1.39707L14.7656 7.46895C15.0594 7.76269 15.0594 8.23769 14.7656 8.52832L8.69063 14.6033C8.39687 14.8971 7.92188 14.8971 7.63125 14.6033L6.9375 13.9096C6.64062 13.6127 6.64688 13.1283 6.95 12.8377L10.7156 9.25019H1.73438C1.31875 9.25019 0.984375 8.91582 0.984375 8.50019V7.5002C0.984375 7.08457 1.31875 6.7502 1.73438 6.7502H10.7156L6.95 3.1627C6.64375 2.87207 6.6375 2.3877 6.9375 2.09082Z" fill={`${last == (Math.floor(current / pageSize) + 1) ? "#888b9e" : "black"}`}/>
                    </g>
                  </svg>
                </span>
              </button>
            </li>
          </ul>
        </nav>
      ) : (
        ""
      )}
    </section>
    {showModal && <CollaboratorsModal idProject={idProject} onClose={() => setShowModal(false)} />}
    </>
  );
};

const Tab = ({ title, index, isSelected, isCompleted, onClick }) => {
  const { getL10nInstance } = useContext(UserContext)
  const [l10n, setL10n] = useState(null)

  useEffect(() => {
    (async () => {
      const instance = await getL10nInstance()
      setL10n(instance)
    })()
  }, [])

  const getClasses = () => {
    if (isSelected) {
      return "text-black border-t-2 border-black";
    } else if (isCompleted) {
      return "text-[#FE8C18] border-t-2";
    }
    return "text-gray-400 border-t-2 border-gray-300";
  };

  const getStepClasses = () => {
    if (isSelected) {
      return "";
    } else if (isCompleted) {
      return "text-[#AEAFB1]";
    }
    return "";
  };

  const getTitleClasses = () => {
    if (isSelected) {
      return "text-[#6A6A6A]";
    } else if (isCompleted) {
      return "text-[#939597]";
    }
    return "";
  };

  return (
    <button
      onClick={onClick}
      className={`text-base ${getClasses()} focus:outline-none text-left`}
    >
      <div className={`font-bold mt-4 ${getStepClasses()}`}>{l10n && l10n.getString('Step')} {index + 1}</div>
      <div className={`${getTitleClasses()}`}>{l10n && l10n.getString(title)}</div>
    </button>
  );
};

const Tabs = ({ tabs, selectedTab, onTabClick }) => {
  const { getL10nInstance } = useContext(UserContext)
  const [l10n, setL10n] = useState(null)

  useEffect(() => {
    (async () => {
      const instance = await getL10nInstance()
      setL10n(instance)
    })()
  }, [])

  return (
    <div className="grid grid-cols-2 gap-4">
      {tabs.map((tab, index) => (
        <Tab
          key={tab.title}
          title={l10n && l10n.getString(tab.title)}
          index={index}
          isSelected={tab.title === selectedTab}
          isCompleted={tab.completed}
          onClick={() => onTabClick(tab.title)}
        />
      ))}
    </div>
  );
};

const CustomButton = ({ onClick, length, disabled }) => {
  const { getL10nInstance } = useContext(UserContext)
  const [l10n, setL10n] = useState(null)

  useEffect(() => {
    (async () => {
      const instance = await getL10nInstance()
      setL10n(instance)
    })()
  }, [])

  return (
    <div className="grid grid-cols-2 justify-between items-center h-28 p-8 bg-white rounded-2xl border border-stone-300">
      <div className="text-gray-800 text-base font-bold">{length}-{l10n && l10n.getString('second audio ad')}</div>
      <div className="flex justify-end">
        <button
          disabled={disabled}
          type="button"
          className="font-semibold text-base text-white w-[178px] h-12 px-5 py-1 bg-fuchsia-900 rounded-[25px] border border-fuchsia-900 justify-center items-center gap-2 inline-flex"
          onClick={onClick}
        >
          {l10n && l10n.getString('Submit project')}
        </button>
      </div>
    </div>
  );
};

export default Widget;
